var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pa-4"},[_c('TabsSliderContainer',{attrs:{"tab":_vm.tab,"items":_vm.items},on:{"update:tab":function($event){_vm.tab=$event}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }